import 'twin.macro';
import { GlobalSearchModal } from 'containers/Search/GlobalSearchModal';
import React from 'react';
import Button from '@teetsh/app/src/components/Buttons/Button';
import { Navbar } from '@teetsh/app/src/components/Navbar';
import { useIsBelowBreakpoint } from '@teetsh/app/src/components/ResponsiveSwitcher/useIsBelowSize';
import { useSidebarStatus } from '@teetsh/app/src/containers/Sidebar/useSidebarStatus';
import SubHeader from '@teetsh/app/src/containers/SubHeader';
import { Bars3Icon as Menu } from '@heroicons/react/24/outline';

interface Props {
  children?: React.ReactNode;
  noMobile?: boolean;
  withSubHeader?: boolean;
  rightContent: React.ReactNode;
}

export function HeaderWrapper({
  children,
  noMobile,
  withSubHeader,
  rightContent,
}: Props) {
  const { open: openSidebar } = useSidebarStatus();
  const isMobile = useIsBelowBreakpoint('md');
  const isMobileOrTablette = useIsBelowBreakpoint('lg');
  const showMobileChildren = isMobile && !noMobile && children;

  // Ici je mets z-20 car sinon collision avec l'editeur dans les séquences
  // nb : z-20 est utilisé pour les modales, il ne faut pas le dépasser
  return (
    <>
      <GlobalSearchModal />
      <div tw="sticky top-0 z-20 border-b border-neutral-quiet -mb-px">
        <Navbar tw="z-20">
          <div tw="mr-2 min-w-0 flex items-center space-x-2">
            {isMobileOrTablette && (
              <Button
                onClick={() => openSidebar()}
                minimal
                large
                icon={Menu}
                aria-label="Ouvrir le menu"
              />
            )}
            {!isMobile && children ? children : null}
          </div>
          {rightContent}
        </Navbar>
        {showMobileChildren && <Navbar tw="-mt-2 z-10">{children}</Navbar>}
      </div>
      {withSubHeader && <SubHeader />}
    </>
  );
}
